import { Divider, Button as MuiButton, CircularProgress } from '@mui/material';
import { Trash2 } from '@globalvisioninc/assets/icons';
import { Button } from '@globalvisioninc/ui/button';
import { useConfirmation } from 'utils';
import GVTypography from 'components/lib/GVTypography/GVTypography';
import GVTextField from 'components/lib/GVTextField/GVTextField';
import MyAccountCard from '../Card';
import { CopyButton } from '../myTeam/CopyButton';
import { useApiKey } from 'store/queries/key/key';
import styles from './APIKey.module.css';

const APIKey = () => {
  const { apiKey, generateKeyMutation, deleteKeyMutation } = useApiKey();
  const confirm = useConfirmation();

  // Generate Api key here and set Generating Key to false on success or error setGeneratingKey(false);
  const generateApiKey = (): void => {
    generateKeyMutation.mutate();
  };

  const handleDeleteApiKey = (): void => {
    confirm({
      variant: 'danger',
      title: 'Delete API Key',
      description: 'Are you sure you would like to delete your API key?',
      acceptLabel: 'Confirm',
    }).then(() => {
      deleteKeyMutation.mutate();
    });
  };

  return (
    <MyAccountCard title={<GVTypography variant="h6">Your API Key</GVTypography>}>
      <>
        <Divider light />
        <div className={styles.container}>
          <GVTypography variant="h6">Create and manage your account&apos;s API Key below</GVTypography>
          <GVTypography variant="subtitle1" color="textSecondary">
            Copy this API key into your 3rd party application that needs access to the Verify Compare API. Your API key
            should be managed like passwords. Keep it a secret.
          </GVTypography>
          <GVTextField
            label="Your API key"
            id="api-key-input"
            value={apiKey || ''}
            isReadOnly
            elementEnd={
              <>
                <CopyButton text={apiKey || ''} label="API key" isDisabled={!apiKey} />
                <Button.Root
                  mode="tertiary"
                  aria-label="Delete API key"
                  onClick={handleDeleteApiKey}
                  isDisabled={!apiKey}
                >
                  <Trash2 />
                </Button.Root>
              </>
            }
          />
          <div className={styles.actions}>
            <MuiButton
              id="generate-api-key"
              onClick={generateApiKey}
              variant="contained"
              color={generateKeyMutation.isPending ? 'primary' : 'secondary'}
              size="large"
              disabled={Boolean(apiKey)}
            >
              {generateKeyMutation.isPending ? (
                <>
                  <CircularProgress className={styles.saving} size={14} color="inherit" />
                  Generating New API Key
                </>
              ) : (
                <>Generate New API Key</>
              )}
            </MuiButton>
          </div>
        </div>
      </>
    </MyAccountCard>
  );
};

export default APIKey;
